// extracted by mini-css-extract-plugin
module.exports = {"ulList":"rich-text_ulList__HUc67","olList":"rich-text_olList__gRIgt","listItem":"rich-text_listItem__yWJRf"};